export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13369.04c6c888.jpg";